import {
  HubIcon,
  HubButton,
  HubHookFormInput,
  HubHookFormTimePicker,
  StationHookFormSelect,
} from "../../components";
import { StyledCell, StyledStack } from "./styles";

const TableRowSx = {
  justifyItems: "center",
  ".DipRowButton": { display: "none" },
  "&:hover": { ".DipRowButton": { display: "inline" } },
};

const WaxTableRow = ({
  basePath,
  idx = 0,
  remove = () => {},
  getFieldProps = () => ({}),
  handleStationChange = () => {},
  locationId,
  ...rest
}) => {
  const row = `${basePath}.${idx}`;

  const cellAttrs = (col) => ({
    "data-wax-row": idx,
    "data-wax-col": col,
  });

  return (
    <StyledStack sx={TableRowSx} data-wax-row={idx} {...rest}>
      <StyledCell direction="row" gap="0px" sx={{ cursor: "grab" }}>
        <HubIcon icon="MoreVertical" size="10px" />
        <HubIcon icon="MoreVertical" size="10px" sx={{ ml: "-7px" }} />
      </StyledCell>
      <StationHookFormSelect
        name={`${row}.stationId`}
        key={`${row}.stationId`}
        shouldUnregister={false}
        department={1}
        {...getFieldProps(`${row}.stationId`)}
        onChange={(e) => handleStationChange(row, e.target.value)}
        hideLabel
        required
        formControlProps={cellAttrs(1)}
      />
      <HubHookFormTimePicker
        name={`${row}.leadTime`}
        key={`${row}.leadTime`}
        {...getFieldProps(`${row}.leadTime`)}
        shouldUnregister={false}
        placeholder="124"
        required
        formControlProps={cellAttrs(2)}
      />
      <HubHookFormTimePicker
        name={`${row}.cycleTime`}
        key={`${row}.cycleTime`}
        {...getFieldProps(`${row}.cycleTime`)}
        shouldUnregister={false}
        placeholder="0.12"
        required
        formControlProps={cellAttrs(3)}
      />
      <HubHookFormInput
        name={`${row}.notes`}
        key={`${row}.notes`}
        {...getFieldProps(`${row}.notes`)}
        shouldUnregister={false}
        formControlProps={cellAttrs(4)}
      />
      <StyledCell>
        <HubButton
          icon="X"
          variant="text"
          iconProps={{ size: 12 }}
          onClick={() => remove(idx)}
          color="neutral"
        />
      </StyledCell>
    </StyledStack>
  );
};

export default WaxTableRow;
